import { CDN } from "@/lib/cdn";

export function getDonImage(donId: string): string {
  let region = "en";
  return `${CDN}/games/one-piece/images/${region}/DON/${donId}.webp`;
}
